class DraggerControl {
	constructor(container) {
		this.container = container;

		if (this.container === null) {
			return console.error("DraggerControl: Container not found");
		}

		const data_attribute = this.container.getAttribute("data-area-anchor");

		if (!data_attribute) {
			return console.error("DraggerControl: Data attribute not found");
		}

		this.target = document.getElementById(data_attribute);

		if (!this.target) {
			return console.error(
				"DraggerControl: Target node not found",
				this.container,
			);
		}

		this.left = this.container.querySelector('[data-direction="left"]');
		this.right = this.container.querySelector('[data-direction="right"]');

		if (!this.left) {
			console.warn("DraggerControl: Left button not found");
		}

		if (!this.right) {
			console.warn("DraggerControl: Right button not found");
		}

		this.init();
	}

	init() {
		this.left.addEventListener("click", (e) => this.handleClick(e, "left"));
		this.right.addEventListener("click", (e) => this.handleClick(e, "right"));

		this.target.addEventListener("scroll", (e) => this.updateDisabledState(e));

		this.updateDisabledState();
	}

	handleClick(event, direction) {
		this.target.scrollBy({
			left: direction === "left" ? -350 : 350,
			behavior: "smooth",
		});
	}

	updateDisabledState() {
		this.left.disabled = this.target.scrollLeft === 0;

		this.right.disabled =
			this.target.scrollLeft ===
			this.target.scrollWidth - this.target.clientWidth;
	}
}

const nodes = document.querySelectorAll(
	".wp-block-steam-blocks-scroll-area-controls",
);
nodes.forEach((el) => new DraggerControl(el));
